import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=45364412&scoped=true&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=45364412&lang=scss&scoped=true&"
import style1 from "./StatusBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45364412",
  null
  
)

export default component.exports